import { PriceCategoryValidity, SeatmapErrorCode, SeatmapErrorEvent, SeatmapState, SelectableInfo, StructuredPricelevel, TicketTypeItem, TicketTypeValidity } from "@/domain/ticket-selection";
import { ErrorType } from "@eventim/seatmap-client";
import { ArrayHelper } from "webshop-modules/helper/Array.helper";

export class SeatmapValidator {

    public static isSizeValidFor(maxNumberOfTickets: number, currentNumberOfTickets: number): boolean {
        return maxNumberOfTickets >= currentNumberOfTickets;
    }

    public static isCartSizeValidFor(state, currentNumberOfTickets): boolean {
        const maxOrder = state.maxTicketsOrder - state.cartItems;

        return state.maxTicketsCart !== null && state.maxTicketsCart < state.maxTicketsOrder
            ? state.maxTicketsCart - state.cartItems >= currentNumberOfTickets
            : maxOrder >= currentNumberOfTickets;
    }

    public static arePriceCategoriesValidFor(state: SeatmapState): PriceCategoryValidity[] {
        const priceCategoryList: Map<number, SelectableInfo[]> = new Map();
        const validity: PriceCategoryValidity[] = [];

        state.structuredSelection.forEach(pricelevel => {
            if (!priceCategoryList.has(pricelevel.selectionInfo.priceCategoryId)) {
                priceCategoryList.set(pricelevel.selectionInfo.priceCategoryId, [ pricelevel.selectionInfo ])
            } else {
                priceCategoryList.set(pricelevel.selectionInfo.priceCategoryId,
                    priceCategoryList.get(pricelevel.selectionInfo.priceCategoryId)!.concat(pricelevel.selectionInfo))
            }
        });

        priceCategoryList.forEach(item => {
            validity.push({
                id: item[0].priceCategoryId,
                max: item[0].maxTickets < item.length
            });
        });

        return validity.filter(item => item.max);
    }

    public static areTicketTypesValidFor(state: SeatmapState): TicketTypeValidity[] {

        const selection: TicketTypeItem[] = state.structuredSelection.map(
            pricelevel => pricelevel.selectionInfo.ticketTypes.reduce(
                (prev, next) => !prev || !prev.active ? next : prev)
        );

        const ticketTypeList: Map<number, TicketTypeItem[]> = new Map();
        const validity: TicketTypeValidity[] = [];

        selection.forEach(item => {
            !ticketTypeList.has(item.priceId)
                ? ticketTypeList.set(item.priceId, [item])
                : ticketTypeList.set(item.priceId, ticketTypeList.get(item.priceId)!.concat(item))
        });

        ticketTypeList.forEach(item => {
            const minRestrictionFailed = item[0].min > item.length;
            const maxRestrictionFailed = item[0].max < item.length;
            const stepRestrictionFailed = item.length % item[0].step > 0;

            validity.push({
                id: item[0].priceId,
                min: minRestrictionFailed,
                max: maxRestrictionFailed,
                step: stepRestrictionFailed
            })
        });

        return validity.filter(item => item.step || item.min || item.max);
    }

    public static hasTokenValidityIssue(e: SeatmapErrorEvent): boolean {
        return e.detail.error.some(error =>
            error.type === ErrorType.API &&
            error.data &&
            (error.data.errorCode === SeatmapErrorCode.NOT_LOGGED_IN || error.data.errorCode === SeatmapErrorCode.UNAUTHORIZED)
        );
    }

    public static isCurrencyValidFor(selection: StructuredPricelevel[]): boolean {
        const firstCurrency = selection[0].selectionInfo.currency;

        return selection.every(pricelevel => pricelevel.selectionInfo.currency === firstCurrency);
    }
}
